// extracted by mini-css-extract-plugin
export default {"root":"UploadImage_root__Sj8Bu","image":"UploadImage_image__EwrgR","error":"UploadImage_error__DrFXE"};